import { Component, OnInit, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Absence } from 'src/app/_model/Absence';
import { AbsenceService } from 'src/app/_services/absence.service';
import { ToastrService } from 'ngx-toastr';
import { WfApproveRequest } from 'src/app/_model/request/WfApproveRequest';
import { User } from 'src/app/_model/user';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-approveselected',
  templateUrl: './approveselected.component.html',
  styleUrls: ['./approveselected.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class ApproveselectedComponent implements OnInit {
  request: WfApproveRequest = new WfApproveRequest();
   currentUser: User;
  constructor(public dialogRef: MatDialogRef<ApproveselectedComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Absence[],
    private absenceService: AbsenceService,
    private authService: AuthenticationService,
    private toastr: ToastrService) {
      this.currentUser = this.authService.currentUserValue;
     }

  ngOnInit() {
  }
  approveSelected(){

    this.data.forEach(element => {
      this.request.employeeId = this.currentUser.employeeId;
      this.request.operationRecordId = element.id;
      this.request.operationTableName = 'ABSENCE';
      this.request.fileList=[];
      this.absenceService.approveAbsence(this.request).subscribe(result => {
        this.toastr.success('Onaylama işlemi başarılı', '');
        this.dialogRef.close();
      }, error => {
        this.toastr.error(error.error.msg, 'Hata');
        this.dialogRef.close();
      });
    });
    
  }
}
